"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationOverviewInfoTableSeats = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const rateTypeMapper_1 = require("../../../../PriceVariant/rateTypeMapper");
require("./index.scss");
const ReservationOverviewInfoTableSeats = (props) => {
    const { className, seats } = props;
    const classNames = (0, classnames_1.default)('reservation-overview-info-table-seats', className);
    const getSeatColorModifier = (rateTariffType) => {
        switch (rateTypeMapper_1.rateTypeToModifierMap[rateTariffType]) {
            case 'green':
                return 'reservation-overview-info-table-seats__label--green';
            case 'blue':
                return 'reservation-overview-info-table-seats__label--blue';
            default:
                return 'reservation-overview-info-table-seats__label--green';
        }
    };
    return (react_1.default.createElement("div", { className: classNames },
        seats.length > 0 && (react_1.default.createElement("div", { className: 'reservation-overview-info-table__title' },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepReservationOverview/ReservationOverviewInfo/ReservationOverviewInfoTable:SeatNumberTitle', defaultMessage: 'Seat number' }))),
        seats.map((seat, idx) => (react_1.default.createElement("div", { key: idx, className: 'reservation-overview-info-table-seats__seat' },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('reservation-overview-info-table-seats__label', getSeatColorModifier(seat.rateTariffType)) }, seat.number),
            react_1.default.createElement("div", { className: 'reservation-overview-info-table-seats__price' },
                "CHF ",
                seat.price))))));
};
exports.ReservationOverviewInfoTableSeats = ReservationOverviewInfoTableSeats;
//# sourceMappingURL=index.js.map